import { states } from 'moo';

const getChatbotMessageLexer = () => {
  return states({
    main: {
      continueMarker: {
        match: /<<continue\/>>/
      },
      // Keep code block handling separate and high priority
      codeBlock: {
        match: /```[\s\S]*?```/,
        lineBreaks: true
      },
      // Match the start of the diffs structure
      diffsStart: {
        match: /<\s*diffs\s*>/,
        push: "in_diffs",
        lineBreaks: true
      },
      // Fallback for any other content in the main scope
      otherContent: {
        match: /(?:(?!<\s*diffs\s*>|```|<<continue\/>>)[\s\S])+/,
        lineBreaks: true
      },
      // Handle whitespace in the main scope
      WS: {
        match: /\s+/,
        lineBreaks: true
      },
      // Match individual characters that weren't matched by other rules in main
      // This helps consume the whole input, potentially identifying unexpected chars
      char: {
        match: /[\s\S]/,
        lineBreaks: true
      }
    },
    in_diffs: {
      continueMarker: {
        match: /<<continue\/>>/
      },
      diffsEnd: {
        match: /<\/\s*diffs\s*>/,
        next: "main",
        lineBreaks: true
      },
      diffsStartNested: {
        match: /<\s*diffs\s*>/,
        push: "in_diffs",
        lineBreaks: true
      },
      diffStart: {
        match: /<\s*diff\s*>/,
        push: "in_diff",
        lineBreaks: true
      },
      // fallback for unexpected tag closings
      locationEnd: {
        match: /<\/\s*location\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      searchEnd: {
        match: /<\/\s*search\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      replaceEnd: {
        match: /<\/\s*replace\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      diffEnd: {
        match: /<\/\s*diff\s*>/,
        next: "in_diffs",
        lineBreaks: true
      },
      // Ignore whitespace within <diffs> but outside <diff>
      WS: {
        match: /\s+/,
        lineBreaks: true
      },
      // Fallback for unexpected characters
      char: {
        match: /[\s\S]/,
        lineBreaks: true
      }
    },
    in_diff: {
      continueMarker: {
        match: /<<continue\/>>/
      },
      // Handle nested diff start
      diffStartNested: {
        match: /<\s*diff\s*>/,
        push: "in_diff",
        lineBreaks: true
      },
      // Standard tags within diff
      diffEnd: {
        match: /<\/\s*diff\s*>/,
        next: "in_diffs",
        lineBreaks: true
      },
      locationStart: {
        match: /<\s*location\s*>/,
        push: "in_location",
        lineBreaks: true
      },
      searchStart: {
        match: /<\s*search\s*>/,
        push: "in_search",
        lineBreaks: true
      },
      replaceStart: {
        match: /<\s*replace\s*>/,
        push: "in_replace",
        lineBreaks: true
      },
      // fallback for unexpected tag closings
      locationEnd: {
        match: /<\/\s*location\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      searchEnd: {
        match: /<\/\s*search\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      replaceEnd: {
        match: /<\/\s*replace\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      // Ignore whitespace within <diff> but outside the inner tags
      WS: {
        match: /\s+/,
        lineBreaks: true
      },
      // Fallback for unexpected characters
      char: {
        match: /[\s\S]/,
        lineBreaks: true
      }
    },
    in_location: {
      continueMarker: {
        match: /<<continue\/>>/
      },
      // Interruptions / Error Handling
      diffEndInterrupt: {
        match: /<\/\s*diff\s*>/,
        push: "in_diffs",
        lineBreaks: true
      },
      diffStartInterrupt: {
        match: /<\s*diff\s*>/,
        push: "in_diff",
        lineBreaks: true
      },
      diffsEndInterrupt: {
        match: /<\/\s*diffs\s*>/,
        push: "main",
        lineBreaks: true
      },
      diffsStartInterrupt: {
        match: /<\s*diffs\s*>/,
        push: "in_diffs",
        lineBreaks: true
      },
      searchStartInterrupt: {
        match: /<\s*search\s*>/,
        push: "in_search",
        lineBreaks: true
      },
      replaceStartInterrupt: {
        match: /<\s*replace\s*>/,
        push: "in_replace",
        lineBreaks: true
      },
      // Handle nested location start (pushes the same state again)
      locationStartNested: {
        match: /<\s*location\s*>/,
        push: "in_location",
        lineBreaks: true
      },
      // Handle the closing tag
      locationEnd: {
        match: /<\/\s*location\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      // Updated content lookahead for flexible tags, diffEnd, and diffStart interrupts
      content: {
        match: /(?:(?!<\/\s*location\s*>|<\s*search\s*>|<\s*replace\s*>|<\s*location\s*>|<\/\s*diff\s*>|<\s*diff\s*>|<\s*diffs\s*>|<\/\s*diffs\s*>|<<continue\/>>)[\s\S])+/,
        lineBreaks: true
      },
      // Allow whitespace within content
      WS: {
        match: /\s+/,
        lineBreaks: true
      }
    },
    in_search: {
      continueMarker: {
        match: /<<continue\/>>/
      },
      // Interruptions / Error Handling
      diffEndInterrupt: {
        match: /<\/\s*diff\s*>/,
        push: "in_diffs",
        lineBreaks: true
      },
      diffStartInterrupt: {
        match: /<\s*diff\s*>/,
        push: "in_diff",
        lineBreaks: true
      },
      diffsEndInterrupt: {
        match: /<\/\s*diffs\s*>/,
        push: "main",
        lineBreaks: true
      },
      diffsStartInterrupt: {
        match: /<\s*diffs\s*>/,
        push: "in_diffs",
        lineBreaks: true
      },
      locationStartInterrupt: {
        match: /<\s*location\s*>/,
        push: "in_location",
        lineBreaks: true
      },
      replaceStartInterrupt: {
        match: /<\s*replace\s*>/,
        push: "in_replace",
        lineBreaks: true
      },
      // Nested search start
      searchStartNested: {
        match: /<\s*search\s*>/,
        push: "in_search",
        lineBreaks: true
      },
      // Closing tag
      searchEnd: {
        match: /<\/\s*search\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      // Updated content lookahead
      content: {
        match: /(?:(?!<\/\s*search\s*>|<\s*location\s*>|<\s*replace\s*>|<\s*search\s*>|<\/\s*diff\s*>|<\s*diff\s*>|<\s*diffs\s*>|<\/\s*diffs\s*>|<<continue\/>>)[\s\S])+/,
        lineBreaks: true
      },
      WS: {
        match: /\s+/,
        lineBreaks: true
      }
    },
    in_replace: {
      continueMarker: {
        match: /<<continue\/>>/
      },
      // Interruptions / Error Handling
      diffEndInterrupt: {
        match: /<\/\s*diff\s*>/,
        push: "in_diffs",
        lineBreaks: true
      },
      diffStartInterrupt: {
        match: /<\s*diff\s*>/,
        push: "in_diff",
        lineBreaks: true
      },
      diffsEndInterrupt: {
        match: /<\/\s*diffs\s*>/,
        push: "main",
        lineBreaks: true
      },
      diffsStartInterrupt: {
        match: /<\s*diffs\s*>/,
        push: "in_diffs",
        lineBreaks: true
      },
      locationStartInterrupt: {
        match: /<\s*location\s*>/,
        push: "in_location",
        lineBreaks: true
      },
      searchStartInterrupt: {
        match: /<\s*search\s*>/,
        push: "in_search",
        lineBreaks: true
      },
      // Nested replace start
      replaceStartNested: {
        match: /<\s*replace\s*>/,
        push: "in_replace",
        lineBreaks: true
      },
      // Closing tag
      replaceEnd: {
        match: /<\/\s*replace\s*>/,
        next: "in_diff",
        lineBreaks: true
      },
      // Updated content lookahead
      content: {
        match: /(?:(?!<\/\s*replace\s*>|<\s*location\s*>|<\s*search\s*>|<\s*replace\s*>|<\/\s*diff\s*>|<\s*diff\s*>|<\s*diffs\s*>|<\/\s*diffs\s*>|<<continue\/>>)[\s\S])+/,
        lineBreaks: true
      },
      WS: {
        match: /\s+/,
        lineBreaks: true
      }
    }
  });
};
var ChatbotMessageTokenType = /* @__PURE__ */ function(ChatbotMessageTokenType2) {
  ChatbotMessageTokenType2["CodeBlock"] = "codeBlock";
  ChatbotMessageTokenType2["DiffsStart"] = "diffsStart";
  ChatbotMessageTokenType2["DiffsStartNested"] = "diffsStartNested";
  ChatbotMessageTokenType2["OtherContent"] = "otherContent";
  ChatbotMessageTokenType2["WS"] = "WS";
  ChatbotMessageTokenType2["Char"] = "char";
  ChatbotMessageTokenType2["DiffsEnd"] = "diffsEnd";
  ChatbotMessageTokenType2["DiffStart"] = "diffStart";
  ChatbotMessageTokenType2["DiffStartNested"] = "diffStartNested";
  ChatbotMessageTokenType2["DiffEnd"] = "diffEnd";
  ChatbotMessageTokenType2["LocationStart"] = "locationStart";
  ChatbotMessageTokenType2["LocationStartNested"] = "locationStartNested";
  ChatbotMessageTokenType2["SearchStart"] = "searchStart";
  ChatbotMessageTokenType2["SearchStartNested"] = "searchStartNested";
  ChatbotMessageTokenType2["ReplaceStart"] = "replaceStart";
  ChatbotMessageTokenType2["ReplaceStartNested"] = "replaceStartNested";
  ChatbotMessageTokenType2["DiffEndInterrupt"] = "diffEndInterrupt";
  ChatbotMessageTokenType2["DiffStartInterrupt"] = "diffStartInterrupt";
  ChatbotMessageTokenType2["DiffsEndInterrupt"] = "diffsEndInterrupt";
  ChatbotMessageTokenType2["DiffsStartInterrupt"] = "diffsStartInterrupt";
  ChatbotMessageTokenType2["SearchStartInterrupt"] = "searchStartInterrupt";
  ChatbotMessageTokenType2["ReplaceStartInterrupt"] = "replaceStartInterrupt";
  ChatbotMessageTokenType2["LocationEnd"] = "locationEnd";
  ChatbotMessageTokenType2["Content"] = "content";
  ChatbotMessageTokenType2["LocationStartInterrupt"] = "locationStartInterrupt";
  ChatbotMessageTokenType2["SearchEnd"] = "searchEnd";
  ChatbotMessageTokenType2["ReplaceEnd"] = "replaceEnd";
  ChatbotMessageTokenType2["ContinueMarker"] = "continueMarker";
  return ChatbotMessageTokenType2;
}({});

export { ChatbotMessageTokenType, getChatbotMessageLexer };
//# sourceMappingURL=chatbotMessageLexer.js.map
